import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const checks = [
  {
    label: 'Hãy luôn nâng tay vịn trên giường.',
    key: 'fall_education.checked1',
  },
  {
    label:
      'Giữ các nhu yếu phẩm của bệnh nhân gần đó để không bị ngã khi đang với tay lấy đồ vật.',
    key: 'fall_education.checked2',
  },
  {
    label:
      'Dọn dẹp khu vực xung quanh giường khỏi những vật có thể gây ngã (nước, dây điện, dụng cụ, khác).',
    key: 'fall_education.checked3',
  },
  {
    label: 'Người giám hộ nên đi cùng bệnh nhân trong phần lớn thời gian.',
    key: 'fall_education.checked4',
  },
  {
    label:
      'Người giám hộ cần giúp đỡ một bệnh nhân thức dậy vào ban đêm để sử dụng nhà vệ sinh hoặc đi nơi khác',
    key: 'fall_education.checked5',
  },
  {
    label: 'Đừng đứng dậy khỏi giường ngay lập tức nếu cảm thấy chóng mặt.',
    key: 'fall_education.checked6',
  },
  {
    label: 'Nếu bạn cần giúp đỡ, hãy sử dụng máy nhắn tin để yêu cầu giúp đỡ.',
    key: 'fall_education.checked7',
  },
  {
    label: 'Khi đi xe lăn, hãy đặc biệt cẩn thận vì độ cao sàn khác nhau.',
    key: 'fall_education.checked8',
  },
];

const EducationList = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="Hướng dẫn phòng chống té ngã" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={12}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default EducationList;
